import { render, staticRenderFns } from "./topic_badges.vue?vue&type=template&id=3d2ac36a"
import script from "./topic_badges.vue?vue&type=script&lang=js"
export * from "./topic_badges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports